import axios from 'axios'
import { store } from '../store/store';
import { BaseURL } from '../helper'
import Mgr from '../SecurityService'
const instance = axios.create({
    baseURL: BaseURL
})

let mgr = new Mgr();
instance.interceptors.request.use(async function (config) {
    // Do something before request is sent
   
    store.commit('showLoading', true)
    return config;
}, async function (error) {
    // Do something with request error
    const status = error.response ? error.response.status : null
    if (status === 401) {
        let token = await mgr.getAcessToken()
        instance.defaults.headers.common['Authorization'] = 'Bearer ' + token;
        error.config.headers['Authorization'] = 'Bearer ' + token;
        error.config.baseURL = undefined;
        //store.commit("addtoken", token)
        sessionStorage.setItem("token", token)
        return await instance.request(error.config);
    }
    store.commit('showLoading', false)
    return Promise.reject(error);
});

// Add a response interceptor
instance.interceptors.response.use(function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    store.commit('showLoading', false)
    return response;
}, async function (error) {
    const status = error.response ? error.response.status : null

    if (status === 401) {
        let token = await mgr.getAcessToken()
        instance.defaults.headers.common['Authorization'] = 'Bearer ' + token;
        error.config.headers['Authorization'] = 'Bearer ' + token;
        error.config.baseURL = undefined;
        //store.commit("addtoken", token)
        sessionStorage.setItem("token", token)
        return await instance.request(error.config);
    }
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    store.commit('showLoading', false)
    return Promise.reject(error);
});
export default instance